"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBSlogans", {
  enumerable: true,
  get: function get() {
    return _SVBSlogans.default;
  }
});
var _SVBSlogans = _interopRequireDefault(require("./src/SVBSlogans"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }